export default __webpack_public_path__ + "static/media/Element5.25227afd.png";